// =============================================================================
// src/features/analytics/analytics-motion.ts - Estados temporais de movimento.
// =============================================================================

export const ANALYTICS_EXIT_MOTION_MS = 220;

const ANALYTICS_MOTION_STATE_ATTR = 'data-analytics-motion-state';
const ANALYTICS_MOTION_OPEN_STATE = 'open';
const ANALYTICS_MOTION_CLOSING_STATE = 'closing';

const analyticsMotionTimers = new WeakMap<HTMLElement, number>();

/** Mostra um elemento que pode ter animacao de entrada/saida sem perder estado. */
export function showAnalyticsMotionElement(targetElement: HTMLElement): void {
  clearAnalyticsMotionTimer(targetElement);
  targetElement.hidden = false;
  targetElement.setAttribute(ANALYTICS_MOTION_STATE_ATTR, ANALYTICS_MOTION_OPEN_STATE);
}

/** Fecha visualmente agora e aplica hidden depois do easing terminar. */
export function hideAnalyticsMotionElement(targetElement: HTMLElement): void {
  clearAnalyticsMotionTimer(targetElement);
  targetElement.setAttribute(ANALYTICS_MOTION_STATE_ATTR, ANALYTICS_MOTION_CLOSING_STATE);
  const timerId = window.setTimeout(() => finishAnalyticsMotionHide(targetElement), ANALYTICS_EXIT_MOTION_MS);
  analyticsMotionTimers.set(targetElement, timerId);
}

function finishAnalyticsMotionHide(targetElement: HTMLElement): void {
  targetElement.hidden = true;
  targetElement.removeAttribute(ANALYTICS_MOTION_STATE_ATTR);
  analyticsMotionTimers.delete(targetElement);
}

function clearAnalyticsMotionTimer(targetElement: HTMLElement): void {
  const timerId = analyticsMotionTimers.get(targetElement);
  if (timerId === undefined) return;
  window.clearTimeout(timerId);
  analyticsMotionTimers.delete(targetElement);
}
